export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID || "6a01ba31-0397-46c3-9511-cc076b1d20b5",
        authority: `https://login.microsoftonline.com/ada8b199-c07c-4596-ba92-bbcea977b591`,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: ["User.Read"] // Only include user profile scope for login
};

export const protectedResources = {
    servicenow: {
        endpoint: process.env.REACT_APP_SERVICENOW_API_ENDPOINT || "https://your-servicenow-api-endpoint",
        scopes: [`${process.env.REACT_APP_SERVICENOW_API_SCOPE || "api://6a01ba31-0397-46c3-9511-cc076b1d20b5/access_as_user"}`],
    },
    salesforce: {
        endpoint: process.env.REACT_APP_SALESFORCE_API_ENDPOINT || "https://your-salesforce-api-endpoint",
        scopes: [`${process.env.REACT_APP_SALESFORCE_API_SCOPE || "api://6a01ba31-0397-46c3-9511-cc076b1d20b5/access_as_user"}`],
    }
}
